/** @format */


const tokens = {
  publicApiKey: '1rSFmkUXQ-FRuTXvNUAK6qKtU1k',
  shopDomain: 'visbiomevet.myshopify.com'
};

class JudgemeReviews extends HTMLElement {
  constructor() {
    super();
    this.reviewsWrapper = document.querySelector('judgeme-reviews');
  }

  async connectedCallback() {
    const reviewsUrl = `https://judge.me/api/v1/widgets/all_reviews_page?api_token=${tokens.publicApiKey}&shop_domain=${tokens.shopDomain}`;
    try {
      const response = await fetch(reviewsUrl);
      const reviews = await response.json();
      const parsedNode = new DOMParser().parseFromString(reviews.all_reviews_header, 'text/html');

      this.renderReviews(parsedNode);
      const reviewOpen = document.querySelector('.write-review').addEventListener("click", this.writeReview);
    } catch (error) {
      console.error(error);
    }
  }

  renderReviews(reviews) {
    document.getElementById('totalReviews').innerText = reviews.getElementsByClassName('jdgm-all-reviews__header')[0].getAttribute('data-number-of-reviews');
    document.getElementById('dataAverageRating').innerText = reviews.getElementsByClassName('jdgm-all-reviews__header')[0].getAttribute('data-average-rating');
    document.getElementById('dataAverageRating').style.marginRight = '1rem';
    document.querySelector('.custom-text-warning').innerHTML = reviews.querySelector('.jdgm-all-reviews__summary-stars').outerHTML;
  
    const searchBtn = '<button class="search__button field__button" > <svg class="icon icon-search" aria-hidden="true" focusable="false"><use href="#icon-search"></svg></button>';
  var fiverReviewParent = document.getElementById('fiveReviewParent')
  var fiveReviews =   reviews.getElementsByClassName('jdgm-histogram__row')
  for(let i = 0; i<fiveReviews.length; i++){
    if(fiveReviews[i].getAttribute('data-rating') !== "null"){
      var reviewItem = `<div class="rating-menu"><p>${fiveReviews[i].getAttribute('data-rating')}</p><span class="custom-text-warning star-margin"><span class="jdgm-star jdgm--on"></span></span><hr class="line"><p>${fiveReviews[i].getAttribute('data-frequency')} (${fiveReviews[i].getAttribute('data-percentage')}%)</p></div>`
    fiverReviewParent.innerHTML += reviewItem;
    }
  }

  
  }
   writeReview(){
      document.querySelector('.jdgm-write-rev-link').click();
   }
}

customElements.define('reviews-main-page', JudgemeReviews);

document.querySelector('.write-review').addEventListener("click", () => {
  replaceInputWithButton('.jdgm-submit-rev')
  
  if (window.innerWidth > 990 ) {
    document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '1000px';
  }
  else if(window.innerWidth >= 750 && window.innerWidth < 990 ){
    document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '1050px';
  }
  else{
    document.querySelector('.jdgm--done-setup-widget').style.setProperty('padding-top', '1020px', 'important');
  }
  
});

function replaceInputWithButton(selector) {
  var inputElement = document.querySelector(selector);
  var buttonElement = document.createElement('button');
  
  Array.from(inputElement.attributes).forEach(attr => {
      buttonElement.setAttribute(attr.name, attr.value);
  });
  
  buttonElement.type = 'submit';
  buttonElement.textContent = inputElement.value;
 
  inputElement.parentNode.replaceChild(buttonElement, inputElement);
}